import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { unsubscriberHelper } from 'src/app/core/helpers/unsubscriber.helper';
import { RequestService } from 'src/app/core/services/request/request.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { IonInputConfig } from 'src/app/shared/models/components/ion-input-config';
import { appointmentEndpoints } from 'src/app/core/configs/endpoints';
import { RouterLinkActive, ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-calendar-view-mode-modal',
  templateUrl: './calendar-view-mode-modal.component.html',
  styleUrls: ['./calendar-view-mode-modal.component.scss'],
})
export class CalendarViewModeModalComponent implements OnInit, OnDestroy {

  subscriptions = new Subscription();

  public appPages = [];

  constructor(private fb: FormBuilder,
    private modalController: ModalController,
    private reqService: RequestService,
    private toastService: ToastService,
    private router: Router,
  ) {
    // this.router.events.pipe(filter((e) => e instanceof NavigationEnd), map(() => this.activatedRoute),
    //   map(route => {
    //     while (route.firstChild) { route = route.firstChild; }
    //     return route;
    //   }),
    //   filter(route => route.outlet === 'primary'),
    //   mergeMap(route => route.data)
    // ).subscribe((data) => {
    //   if (data?.noMenu) {
    //     this.hideSideMenu = true;
    //   } else {
    //     this.hideSideMenu = false;
    //   }
    // });
  }

  ngOnInit() {
    this.appPages = [
      { title: 'Listă', url: '/calendar/lista', icon: '1-day' },
      { title: 'Zi', url: '/calendar/zi', icon: 'schedule' },
      {
        title: 'Zile lucrătoare',
        url: '/calendar/zile-lucratoare',
        icon: '3-days',
      },
      { title: 'Săptămână', url: '/calendar/saptamana', icon: '5-days' },
      { title: 'Lună', url: '/calendar/luna', icon: 'month' },
    ];
  }

  closeModal(medicData: any = null) {
    this.modalController.dismiss({
      dismissed: true,
      medicData,
    });

  }

  samePageReset(active) {
     if (active instanceof RouterLinkActive && active.isActive) {
    //   this.sideMenuS.samePageNavigation$.next(true);
     }
     this.closeModal();
  }

  openModal(modalTitle: string = '') {
    // if (modalTitle === 'pacienti') {
    //   this.presentPacient();
    // }
  }

  ngOnDestroy(): void {
    unsubscriberHelper(this.subscriptions);
  }
}
